@if (showHeaders) {
  <div class="headerText">Work Orders</div>
}
@if (showHeaders) {
  <div>
    <div style="text-align: left;">
      <h6>Show:</h6>
      <p-selectButton [options]="types" [(ngModel)]="selectedType" (onChange)="changedType()"></p-selectButton>
    </div>
  </div>
}
@if (showHeaders) {
  <br />
}
<div>
  <app-work-order-filter-bar
    [isDayView]="true"
    [typeOfWorkOrders]="selectedType"
    [rms]="rms"
    [equipmentTypes]="equipmentTypes"
    (OnWoFilteringFinished)="OnWoFilteringFinished()"
    >
  </app-work-order-filter-bar>
</div>

<p-table showGridlines stripedRows responsiveLayout="stack"
  [columns]="cols"
  [value]="allWorkOrders"
  [paginator]="true"
  [rows]="rows"
  [lazy]="true"
  (onLazyLoad)="loadRequestLazy($event)"
  [totalRecords]="totalRecords"
  [loading]="isLoading"
  [sortField]="'CreatedOn'"
  [sortOrder]="-1"
  >
  <ng-template pTemplate="header" let-columns>
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [style.width]="col.width">
          {{col.header}}
          @if (col.header != '') {
            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
            </p-sortIcon>
          }
        </th>
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-workOrder let-columns="columns" let-rowIndex="rowIndex">
    <tr>
      <td><span class="p-column-title">{{columns[0].header}}</span>{{workOrder.number}}</td>
      <td><span class="p-column-title">{{columns[1].header}}</span>{{workOrder.fullName}}</td>
      <!-- <td><span class="p-column-title">{{columns[2].header}}</span>{{workOrder.wellnessTasksCount}}</td>
      <td><span class="p-column-title">{{columns[3].header}}</span>{{workOrder.workTasksCount}}</td> -->
      <td>@if (!workOrder.hidePrice || canSeeHiddenPrice) {
        <span ><span class="p-column-title">{{columns[2].header}}</span>{{workOrder.price | currency: 'USD' : 'symbol'}}</span>
      }</td>
      <td><span class="p-column-title">{{columns[3].header}}</span>{{workOrder.hours}}</td>
      <td><span class="p-column-title">{{columns[4].header}}</span>{{workOrder.createdOn | date: 'shortDate' }}</td>
      <td><span class="p-column-title">{{columns[5].header}}</span>{{workOrder.status}}</td>
      <td>
        <p-button type="button" (click)="edit(maintenanceLink + '/' + workOrder.id)" icon="pi pi-pencil"
          severity="info" >
        </p-button>
        @if (selectedType === 'quote' && workOrder.status !== 'Work Orders Created' && workOrder.status !== 'Credit Card Needed') {
          <p-button
            
            type="button"
            icon="pi pi-trash"
            (click)="delete(workOrder)"
            severity="danger"
            >
          </p-button>
        }
      </td>
    </tr>
  </ng-template>
</p-table>